import { isMatch } from "date-fns/isMatch";

export function isDateOnlyString(value: string): boolean {
  return isMatch(value, "yyyy-MM-dd");
}

export function parseNullableDate(
  value: string | null | undefined,
): Date | null {
  if (!value) return null;

  const parsed = new Date(value);
  return Number.isNaN(parsed.getTime()) ? null : parsed;
}

export function formatDurationMmSs(ms: number): string {
  const totalSeconds = Math.max(0, Math.floor(ms / 1000));
  const minutes = Math.floor(totalSeconds / 60);
  const seconds = totalSeconds % 60;

  return `${minutes.toString().padStart(2, "0")}:${seconds
    .toString()
    .padStart(2, "0")}`;
}
